export default {
      id: "oc-select-switch-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-select-switch",
      toString: function () {
        return this.url;
      }
    }